import { Container, Tabs, Tab, ListGroup, Card } from "react-bootstrap";

const Programs = () => {
  return (
    <section id="programs" className="py-5">
      <Container>
        <h2 className="text-center mb-5 fw-bold">Our Educational Programs</h2>
        <Tabs
          defaultActiveKey="earlyyears"
          className="mb-4 justify-content-center custom-tabs"
        >
          <Tab eventKey="earlyyears" title="Early Years">
            <Card className="border-0 shadow-sm p-4">
              <h3>Foundation Level / Kindergarten (KG)</h3>
              <p>
                <strong>Age:</strong> 5 – 6 years old
              </p>
              <p>
                <strong>Curriculum:</strong> Comprehensive learning objectives
                focused on early development.
              </p>
            </Card>
          </Tab>

          <Tab eventKey="primary" title="Primary & Secondary">
            <Card className="border-0 shadow-sm p-4">
              <h3>Year 1 to Year 9</h3>
              <p>
                <strong>Age:</strong> 6 – 14 years old
              </p>
              <h5>Curriculum Subjects:</h5>
              <div className="d-flex flex-wrap gap-2">
                {[
                  "Art & Design",
                  "Digital Literacy",
                  "English",
                  "English as a Second Language",
                  "Global Perspectives",
                  "Computing",
                  "Mathematics",
                  "Music",
                  "PE",
                  "Science",
                ].map((s) => (
                  <span key={s} className="badge bg-secondary p-2">
                    {s}
                  </span>
                ))}
              </div>
            </Card>
          </Tab>

          <Tab eventKey="upper" title="Upper Secondary">
            <Card className="border-0 shadow-sm p-4">
              <h3>IGCSE O Level</h3>
              <p>
                <strong>Age:</strong> 14 – 16 years old
              </p>
              <p>
                The Cambridge IGCSE O Level is an internationally recognized qualification designed for secondary students. It offers a broad and balanced curriculum that develops critical thinking, problem-solving, and prepares learners for A Levels or higher education pathways worldwide.
              </p>
            </Card>
          </Tab>

          <Tab eventKey="advanced" title="Advanced Level">
            <Card className="border-0 shadow-sm p-4">
              <h3>Cambridge International AS & A level</h3>
              <p>
                <strong>Age:</strong> 16 – 19 years old
              </p>
              <p>
               Cambridge offers over 50 subjects with flexible combinations. Most subjects follow a staged approach, where AS Level covers half of A Level content and can be completed in one year, either as a standalone qualification or as part of A Level.
              </p>
            </Card>
          </Tab>

          <Tab eventKey="ged" title="GED Program">
            <Card className="border-0 shadow-sm p-4 text-white bg-primary">
              <h3>American High School Diploma</h3>
              <p>
                <strong>Age:</strong> Above 16 years old
              </p>
              <p>
                Internationally recognized high school equivalency. A flexible
                pathway to higher education and career opportunities.
              </p>
            </Card>
          </Tab>
        </Tabs>
      </Container>
    </section>
  );
};
export default Programs;
